import { EMPTY_STRING, SearchCardTypes } from "@bonusx-global/bx-design-system";
import get from "lodash/get";
import type { Search } from "../../../../interfaces/Search";
import type { IProductLean } from "../../../../pages/ProductsListPage/entities/product-lean/product-lean.entity.interface";
import type { IProduct as IProductNew } from "../../../../pages/ProductsListPage/entities/product/product.entity.interface";

function isValidServiceCardTypes(value?: string): value is SearchCardTypes {
  if (!value) {
    return false;
  }

  const cardTypes: string[] = Object.values(SearchCardTypes);
  const isValid = cardTypes.includes(value);

  return isValid;
}

export function serviceToResultItem(service: IProductLean | IProductNew): Search.Item {
  const productName = service.name ?? EMPTY_STRING;

  const productSubType: string | undefined = get(service, "subType");
  const currentProductType: string | undefined = productSubType ?? service.type;
  const isValidCardType = isValidServiceCardTypes(currentProductType);
  const productType: SearchCardTypes = isValidCardType ? currentProductType : SearchCardTypes.Other;

  const serviceId = service.id;
  const serviceHasAvailableProperty = "available" in service;
  const serviceAvailable = serviceHasAvailableProperty ? service.available : false;

  const searchItem: Search.Item = {
    url: `/services/${serviceId}`,
    id: serviceId,
    label: productName,
    image: EMPTY_STRING,
    available: serviceAvailable,
    type: productType,
  };

  return searchItem;
}
